import { useQuery } from 'react-query';
import axios from '../utils/axios-util';

const getExportVisualisationSchema = (customer) => {
  return axios({
    url: '/config/' + customer + '/visualisation-schema',
    method: 'get'
  });
};

const useGetExportVisualisationSchema = (customer) => {
  return useQuery(["get", "visSchema", customer], () => getExportVisualisationSchema(customer), {
    enabled: !!customer
  });
};

export default useGetExportVisualisationSchema;